import {SearchAlertConstant} from "../redux_constants/search.constant";
import {loadSlides, loadTags} from "./slides.action";
import {getNewState} from "../redux_reducers/search.reducer";
import {loadGroups} from "./users.action";
import {slideExportStatus, slideTilingStatus, slideUploadStatus} from "../utils/const";

export const searchInitiated = () => ({
    type: SearchAlertConstant.SEARCH_INITIATED
})

export const searchSuccess = () => ({
    type: SearchAlertConstant.SEARCH_SUCCESS
})

export const searchFailed = (error) => ({
    type: SearchAlertConstant.SEARCH_FAILED,
    response: error
})

export const clearAllFilters = () => dispatch => {
    dispatch(loadSlides(getNewState()));
}

export const toggleDefaultOrderUsed = (val) =>  ({
    type: SearchAlertConstant.TOGGLE_ORDER_USED,
    defaultOrderUsed: val
})

export const updateTagsAndSearches = (tags, searches, filters, currentState) => dispatch => {
    dispatch(loadSlides( {
        ...currentState,
        tags: tags,
        searches: searches,
		filters: filters,
        page: 1
    }))
}

export const updateTags = (tags, currentState) => dispatch => {
    var newState = {
        ...currentState,
        tags: tags,
        page: 1
    }
    dispatch(loadSlides(newState));
}

export const changeOrdering = (newOrdering, currentState) => dispatch => {
    dispatch(loadSlides({
        ...currentState,
        ordering: newOrdering,
    }));
}

export const changePage = (pageNumber, currentState) => dispatch => {
    dispatch(loadSlides({
        ...currentState,
        page: pageNumber
    }))
}

export const updateUrlStateInReducer = (oldState) => dispatch => {
    var newState = urlParser(oldState);
    dispatch(loadSlides(newState));
}

export const updateSearchRelatedMetaData = () => dispatch => {
    dispatch(loadTags());
    dispatch(loadGroups());
}

export const urlParser = (parsedPartsOfUrl) => {
    try {
        var url = window.location.href.split('?')[1];
        var partsOfUrl = url.split('&');
		var date_gte;
        let decodedValue;
        partsOfUrl.forEach((part) => {
            var key = part.split('=')[0];
            var value = part.split('=')[1];
            if (key === 'tags') {
                var tags = value.split('%20');
                tags.forEach((tag) => {
                    if (tag.length > 0) {
						if (parsedPartsOfUrl.tags.indexOf(tag.replace('%23', '#')) === -1){
							parsedPartsOfUrl.tags.push(tag.replace('%23', '#'));
						}
                    }
                });
            } else if (key === 'search') {
                if (value.length > 0) {
                    decodedValue = decodeURIComponent(value);
                    if (parsedPartsOfUrl.searches.indexOf(decodedValue) === -1) {
                        parsedPartsOfUrl.searches.push(decodedValue);
                    }
                }
            } else if (key === 'starred') {
				if (parsedPartsOfUrl.filters.indexOf("_Starred") === -1){
					parsedPartsOfUrl.filters.push('_Starred');
				}
            } else if (key === 'case_not_assigned') {
				if (parsedPartsOfUrl.filters.indexOf('_Case not assigned') === -1) {
					parsedPartsOfUrl.filters.push('_Case not assigned');
				}
            } else if (key === 'ordering') {
                parsedPartsOfUrl.ordering = value;
            } else if (key === 'date__gte') {
				date_gte = value;
            } else if (key === 'date__lte') {
				if(parsedPartsOfUrl.filters.indexOf('Date = ' + date_gte + '/' + value) === -1) {
					parsedPartsOfUrl.date__lte = value;
					parsedPartsOfUrl.filters.push('Date = ' + date_gte + '/' + value);
				}
            } else if (key === 'page') {
                parsedPartsOfUrl.page = parseInt(value);
            } else if (key === 'device_id') {
				if (parsedPartsOfUrl.filters.indexOf('Device = ' + parseInt(value)) === -1) {
					parsedPartsOfUrl.filters.push('Device = ' + parseInt(value))
				}
            } else if (key === 'export_status') {
				let filter = 'Export = ' + Object.keys(slideExportStatus).find(key => slideExportStatus[key] === parseInt(value));
				if (parsedPartsOfUrl.filters.indexOf(filter) === -1) {
					parsedPartsOfUrl.filters.push(filter);
				}
			} else if (key === 'upload_status') {
				let filter = 'Upload = ' + Object.keys(slideUploadStatus).find(key => slideUploadStatus[key] === parseInt(value));
				if (parsedPartsOfUrl.filters.indexOf(filter) === -1) {
					parsedPartsOfUrl.filters.push(filter);
				}
			}
			else if (key === 'tiling_status') {
				let filter = 'Tiling = ' + Object.keys(slideTilingStatus).find(key => slideTilingStatus[key] === parseInt(value));
				if (parsedPartsOfUrl.filters.indexOf(filter) === -1) {
					parsedPartsOfUrl.filters.push(filter);
				}
			}
            else if (key === 'archival_status') {
                let filter = 'Archive = ' + value;
                if (parsedPartsOfUrl.filters.indexOf(filter) === -1) {
                    parsedPartsOfUrl.filters.push(filter);
                }
            }
        });
    } catch (err) {
        console.log('Could not parse Url : ' + err.message);
    }
    return parsedPartsOfUrl;
}